import { render } from "./account.vue?vue&type=template&id=24a8cdf6&scoped=true"
import script from "./account.vue?vue&type=script&lang=js"
export * from "./account.vue?vue&type=script&lang=js"

import "./account.vue?vue&type=style&index=0&id=24a8cdf6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-24a8cdf6"

export default script